export enum TaskStatus {
    IDLE,
    PROCESSING,
    STOP, // Manually stopped
    FINISHED, // Task finished,
    PENDING_START // Task was not started because of lack of available threads. Will be started by threads increasing mechanism.
}

export function getPrettyTaskStatus(taskStatus: number): string {
    return ['is idle', 'in process', 'is stopped', 'is finished', 'pending start'][taskStatus];
}

export function getSimplePrettyTaskStatus(taskStatus: number): string {
    return ['idle', 'in process', 'stopped', 'finished', 'pending start'][taskStatus];
}

export function getPrettyTaskStatus2(taskStatus: number): string {
    return ['Waiting', 'In Progress', 'Paused', 'Completed', 'Pending start'][taskStatus];
}

export const tasksStatuses = [
    TaskStatus.IDLE,
    TaskStatus.PROCESSING,
    TaskStatus.STOP,
    TaskStatus.FINISHED,
    TaskStatus.PENDING_START
];
